var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-app", [
    _c(
      "div",
      {
        staticClass: "d-flex justify-center align-center",
        attrs: { id: "background" }
      },
      [
        _c(
          "v-expand-transition",
          [
            _c(
              "v-sheet",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expandCard,
                    expression: "expandCard"
                  }
                ],
                staticClass: "text-center rounded-xl",
                attrs: { id: "card" }
              },
              [_c("nuxt")],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "v-fade-transition",
          [
            _c("FooterLogo", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.expandLogo,
                  expression: "expandLogo"
                }
              ]
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }